import { defineStore } from "pinia";
import useAutosaves from "@/composables/useAutosaves";
import { useMjmlStore } from "@/stores/mjmlStore";
import { IGroupedAutosaves } from "@/schemas/autosave/autosaveSchema";

interface State {
  autosavesEnabled: boolean;
  autosaveInterval: number | undefined;
  defaultIntervalMiliSeconds: number;
  autosaveMenuOpen: boolean;
  groupedAutosaves: IGroupedAutosaves;
  loading: boolean;
  intervalToAutosave?: any;
}

export const useAutosavesStore = defineStore("autosaves", {
  state: (): State => ({
    autosavesEnabled: false,
    autosaveInterval: undefined,
    defaultIntervalMiliSeconds: 60 * 1000,
    autosaveMenuOpen: false,
    groupedAutosaves: {},
    loading: false,
  }),

  getters: {
    autosaveIntervalMiliSeconds(): number {
      const autosaveInterval = this.autosaveInterval;

      if (autosaveInterval !== undefined) {
        // validate minimal interval duration
        if (autosaveInterval < 30) {
          return 30 * 1000;
        }

        //s to ms conversion
        return autosaveInterval * 1000;
      }

      if (
        import.meta.env.MODE === "development" ||
        import.meta.env.MODE === "testing"
      ) {
        return 2000;
      }

      return this.defaultIntervalMiliSeconds;
    },
  },

  actions: {
    clearIntervalToAutosave() {
      if (this.intervalToAutosave) clearInterval(this.intervalToAutosave);
    },

    enableAutosaves(isEnabled: boolean) {
      this.autosavesEnabled = isEnabled;
    },

    setAutosaveInterval(interval: number) {
      this.autosaveInterval = interval;
    },

    setIntervalToAutosave() {
      if (this.autosavesEnabled) {
        const mjmlStore = useMjmlStore();
        const { save } = useAutosaves();
        this.intervalToAutosave = setInterval(() => {
          if (mjmlStore.getEdittedWithoutSave) {
            save();
          }
        }, this.autosaveIntervalMiliSeconds);
      }
    },

    toggleAutosaveMenu() {
      this.autosaveMenuOpen = !this.autosaveMenuOpen;
    },
  },
});
